import { useRoutes } from 'react-router';
import MainRoute from './interviewer/route';
import NotFoundRoute from './shared/404';

export default function Routes() {
  return useRoutes([MainRoute, NotFoundRoute]);
}
